import { render, staticRenderFns } from "./Lgx240573918642509837.vue?vue&type=template&id=008e2956&scoped=true&"
import script from "./Lgx240573918642509837.vue?vue&type=script&lang=js&"
export * from "./Lgx240573918642509837.vue?vue&type=script&lang=js&"
import style0 from "./Lgx240573918642509837.vue?vue&type=style&index=0&id=008e2956&prod&lang=scss&scoped=true&"
import style1 from "./Lgx240573918642509837.vue?vue&type=style&index=1&id=008e2956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008e2956",
  null
  
)

export default component.exports